<div class="floating-label">
    <select [formControlName]="controlName" class="floating-select input" [ngClass]="{ 'no-icon': !showIcon }" (change)="onChange($event)">
        <option *ngFor="let item of optionList" [value]="item.value">{{ shouldTranslateOptions ? (item.text | translate) : item.text }}</option>
    </select>
    <label-extended-control [labelText]="labelText"></label-extended-control>
    <div *ngIf="showIcon" class="icon">
        <span [class]="iconClass"></span>
    </div>
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
